import React from "react";
import ToggleControl, { ToggleControlPropTypes } from "../ToggleControl/ToggleControl";
import "./checkbox.scss";

const Checkbox = props => {
  return <ToggleControl type="checkbox" {...props} />;
};

Checkbox.propTypes = ToggleControlPropTypes;

export default Checkbox;
